import { handleCopyToClipboard } from 'src/utils';

const Footer = (): JSX.Element => {return (
  <footer>
    <div className="panel">
      <div>
        <h2>InfinityLabs R&amp;D</h2>
        <address>
          <button
            className="footer-email"
            type="button"
            onClick={() => {return handleCopyToClipboard('info@infinitylabs.co.il')}}
          >
            info@infinitylabs.co.il
          </button>
          <a href="https://infinitylabs.co.il/" target="_blank" rel="noreferrer">
            Visit infinitylabs.co.il
          </a>
        </address>
        <p className="footer-copy">Copyright &copy; {new Date().getFullYear()}</p>
      </div>
      <nav className="fl" aria-label="Legal">
        <a href="/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a>
        <a href="/eula" target="_blank" rel="noreferrer">End-User License Agreement</a>
      </nav>
    </div>
  </footer>
)};

export default Footer;
